import { render, staticRenderFns } from "./PolicyTable.vue?vue&type=template&id=1000caca&"
import script from "./PolicyTable.vue?vue&type=script&lang=js&"
export * from "./PolicyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports